import ApiService from "../api";

export default class RelatorioEntregasService extends ApiService {

    constructor() {
        super("/api/relatorios/entregas");
    }

    // mesmos parâmetros do filtro da tela, para o relatório, o download e o comparativo
    montarParametros(values) {
        const params = new URLSearchParams();

        if (values.filiais) params.append('filiais', values.filiais);
        if (values.dataInicial) params.append('dataInicial', values.dataInicial);
        if (values.dataFinal) params.append('dataFinal', values.dataFinal);
        // PADRAO (análise atual) ou POR_CARGA (só transportes que existem em Carga de Entrega, desde 01/09/2026)
        if (values.modo) params.append('modo', values.modo);
        // REMESSA (data de entrega) ou CRIACAO (data de criação do registro); só vale na análise por carga
        if (values.campoData) params.append('campoData', values.campoData);

        return params;
    }

    relatorioEntregas(values) {
        return this.get(`?${this.montarParametros(values).toString()}`)
    }

    // Planilha (.xlsx) com as linhas de volume e de retorno do filtro selecionado
    exportarVolumeRetorno(values) {
        return this.getFile(`/exportar?${this.montarParametros(values).toString()}`)
    }

    // Todas as linhas de volume e de retorno de um transporte, no mesmo filtro do comparativo
    detalheTransporte(values, transporte) {
        const params = this.montarParametros(values);
        params.append('transporte', transporte);
        return this.get(`/detalhe-transporte?${params.toString()}`)
    }

    // Confere a planilha de fechamento da Solar com o volume/retorno e a Carga de Entrega do filtro (não grava a planilha)
    conferenciaSolar(values, file) {
        const params = this.montarParametros(values);
        params.delete('modo');
        const formData = new FormData();
        formData.append('file', file);
        return this.post(`/conferencia-solar?${params.toString()}`, formData);
    }

    // Transportes que existem no volume/retorno e não na Carga de Entrega, e vice-versa
    comparativoTransportes(values) {
        return this.get(`/comparativo-transportes?${this.montarParametros(values).toString()}`)
    }

}
